import { Button, Link, Prices } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { ReactElement } from 'react';
import { TSlide } from '~/ui/pages/Home/common/CommonSwiper/types';
import { useTranslation } from 'next-i18next';
import HomeStack from '../HomeStack';

const HomeSlide = (slide: TSlide): ReactElement => {
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const {
    link,
    image,
    name,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    short_description,
    prices,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    image_mobile,
    imgLoading = 'lazy',
    hasHoverCTA = false,
  } = slide;
  return (
    <div className="hp-slide swiper-slide">
      <Link href={link}>
        <HomeStack
          title={name}
          img={image}
          imgMobile={image_mobile || image}
          url={link}
          loading={imgLoading}
          isFlipped
          prices={prices}
          hasHoverCTA={hasHoverCTA}
        />
      </Link>
    </div>
  );
};

export default HomeSlide;
